<div class="video-player {{videoClass}}">
  <div class="video-player__container mx-auto p-4">
    <video-js 
      id="myPlayerID player_{{ randomScrumble }}"
      data-account="6058004204001" 
      [attr.data-player]="videoPlayType" 
      data-embed="default" 
      controls="" 
      [attr.data-video-id]="videoID"
      data-playlist-id="" 
      data-application-id="" 
      [attr.poster]="videoThumbnail" 
      class="vjs-fluid innerWrapper"
    ></video-js>
  </div>
</div>
